import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export function isBrowseSkillsEnabled() {
  return GrowthDiscoveryEpicClient.get('enableBrowseSkillPages');
}

export function previewBrowseSkillsV2() {
  return GrowthDiscoveryEpicClient.preview('enableBrowseSkillPages');
}
